import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import * as Yup from "yup";
import icons from "../../../assets/images/constantIcons";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const AddCateenUsersForm = ({ isOpen, onClose, fetchCateenUsers }) => {
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      password: "",
      password_confirmation: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .trim()
        .matches(/^[A-Za-z\s]+$/, "Name cannot contain numbers or special characters")
        .min(2, "Name must be at least 2 characters")
        .max(25, "Name cannot exceed 25 characters")
        .required("First name is required"),
      last_name: Yup.string()
        .trim()
        .matches(/^[A-Za-z\s]+$/, "Last name cannot contain numbers or special characters")
        .min(2, "Last name must be at least 2 characters")
        .max(25, "Last name cannot exceed 25 characters")
        .required("Last name is required"),
      phone_number: Yup.string()
        .matches(/^[0-9]{10,15}$/, "Enter a valid phone number")
        .required("Phone number is required"),

      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),

      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/\d/, "Password must contain at least one number")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one special character"
        )
        .required("Password is required"),
      password_confirmation: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append("canteen_user[first_name]", values.first_name);
        formData.append("canteen_user[last_name]", values.last_name);
        formData.append("canteen_user[email]", values.email);
        formData.append("canteen_user[password]", values.password);
        formData.append("canteen_user[password_confirmation]", values.password_confirmation);
        formData.append("canteen_user[phone_number]", values.phone_number);
        formData.append("canteen_user[address]", values.address);

        const response = await apiService.post("/canteen_users", formData);
        if (response.status === 201) {
          onClose();
          toast.success("User created successfully!", { duration: 2000 });
          formik.resetForm();
          fetchCateenUsers();
        }
      } catch (errors) {
        handleError(errors);
      }
    },
  });


  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] h-auto overflow-y-auto vertical relative">
        {/* Close Button */}
        <div
          className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
          onClick={() => {
            formik.resetForm();
            onClose();
          }}
        >
          <icons.IoClose className="text-green700" />
        </div>

        <h2 className="text-xl font-semibold mb-5 text-G500">Add Users</h2>

        <form onSubmit={formik.handleSubmit} className="space-y-4">
          {/* Category Name Input */}
          <div className="text-G300">
            <label className="block text-sm mb-2">Name</label>
            <input
              type="text"
              name="first_name"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="Name"
            />
            {formik.errors.first_name && formik.touched.first_name && (
              <div className="text-red text-sm mt-1">{formik.errors.first_name}</div>
            )}
          </div>
          <div className="text-G300">
            <label className="block text-sm mb-2">Last Name</label>
            <input
              type="text"
              name="last_name"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="Name"
            />
            {formik.errors.first_name && formik.touched.first_name && (
              <div className="text-red text-sm mt-1">{formik.errors.first_name}</div>
            )}
          </div>
          {/* Email */}
          <div className="text-G300">
            <label className="block text-sm mb-2">Email</label>
            <input
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="nathan.roberts@example.com"
            />
            {formik.errors.email && formik.touched.email && (
              <div className="text-red text-sm">{formik.errors.email}</div>
            )}
          </div>

          {/* Mobile Number */}
          <div className="text-G300">
            <label className="block text-sm mb-2">Mobile Number <span className="text-red ">*</span></label>
            <PhoneInput
              country={'in'}
              value={formik.values.phone_number}
              onChange={(value) => formik.setFieldValue('phone_number', value)}
              onBlur={formik.handleBlur}
              disableDropdown
              enableSearch={false}
              countryCodeEditable={false}
              onlyCountries={['in']}
              placeholder="80679 35463"
              inputProps={{
                name: 'phone_number',
                required: true,
                className: 'w-full inputtext',
              }}
              buttonStyle={{ display: 'none' }}
            />
            {formik.errors.phone_number && formik.touched.phone_number && (
              <div className="text-red text-sm">
                {formik.errors.phone_number}
              </div>
            )}

          </div>
          <div className="text-G300">
            <label className="block text-sm mb-2">Address</label>
            <input
              type="text"
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="address"
            />
            {formik.errors.address && formik.touched.address && (
              <div className="text-red text-sm mt-1">{formik.errors.address}</div>
            )}
          </div>

          <div className="text-G300 relative">
            <label className="block text-sm font-normal mb-2">Password</label>
            <div className="relative w-full">
              <input
                type={showPassword ? "text" : "password"} // Toggle between text & password
                name="password"
                placeholder="Password"
                className="inputtext w-full pr-10 py-2 pl-3 border border-gray-300 rounded-md" // Ensure spacing & styling
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                autoComplete="current-password"
              />
              <span
                className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-[#0D762A]"
                onClick={() => setShowPassword(!showPassword)} // Toggle state
              >
                {showPassword ? (
                  <icons.FaEye className="w-5 h-5" />
                ) : (
                  <icons.FaEyeSlash className="w-5 h-5" />
                )}
              </span>
            </div>
            {formik.touched.password && formik.errors.password && (
              <div className="text-red text-sm">{formik.errors.password}</div>
            )}
          </div>

          <div className="text-G300 relative">
            <label className="block text-sm font-normal mb-2">
              Confirm Password
            </label>

            <div className="relative w-full">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="password_confirmation"
                placeholder="Confirm password"
                className="inputtext w-full pr-10 py-2 pl-3 border border-gray-300 rounded-md"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password_confirmation}
                autoComplete="new-password"
              />

              {/* Eye Icon (Clickable) */}
              <span
                className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-[#0D762A]"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? (
                  <icons.FaEye className="w-5 h-5" />
                ) : (
                  <icons.FaEyeSlash className="w-5 h-5" />
                )}
              </span>
            </div>

            {/* Validation Error Message */}
            {formik.touched.password_confirmation &&
              formik.errors.password_confirmation && (
                <div className="text-red text-sm">
                  {formik.errors.password_confirmation}
                </div>
              )}
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-4 pt-4">
            <button
              type="button"
              onClick={() => {
                formik.resetForm();
                onClose();
              }}
              className="w-[75px] sm:w-[93px] text-sm py-2 text-center border border-green text-green rounded-lg"
            >
              Close
            </button>
            <button
              type="submit"
              className="w-[75px] sm:w-[93px] text-sm text-center py-2 bg-green text-white rounded-lg"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCateenUsersForm;
